var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customer-chat" },
    [
      _vm.loading
        ? _c("div", { staticClass: "loading-wrapper" }, [_c("loading")], 1)
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading
        ? [
            _c(
              "section",
              { ref: "messagesEl", staticClass: "chat-messages" },
              [
                _vm.chatMessages.length < _vm.totalChatMessages
                  ? _c("div", { staticClass: "chat-load-more" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-default",
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              _vm.loadMore($event)
                            },
                          },
                        },
                        [_vm._v("\n          Load more\n        ")]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.chatMessageGroups, function (group) {
                  return _c("div", { staticClass: "message-groups" }, [
                    _c("div", { staticClass: "message-group-date" }, [
                      _vm._v(
                        "\n          " + _vm._s(group.date) + "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "message-group-messages" },
                      _vm._l(group.messages, function (chatMessage) {
                        return _c(
                          "div",
                          {
                            staticClass: "message clearfix",
                            class: {
                              incoming:
                                chatMessage.messageDirection === "INCOMING",
                              outgoing:
                                chatMessage.messageDirection === "OUTGOING",
                              event:
                                chatMessage.type ===
                                _vm.CUSTOMER_CHAT_MESSAGE_TYPES.EVENT,
                            },
                          },
                          [
                            _c("div", { staticClass: "message-date" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm._f("formatDate")(
                                      chatMessage.created,
                                      "h:mm a"
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "cols" }, [
                              chatMessage.type !==
                              _vm.CUSTOMER_CHAT_MESSAGE_TYPES.EVENT
                                ? _c("div", { staticClass: "left-col" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "sender",
                                        class: {
                                          "sender-system":
                                            chatMessage.fromSystem,
                                        },
                                      },
                                      [
                                        chatMessage.messageDirection ===
                                        "INCOMING"
                                          ? _c("span", [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(_vm.customerInitials) +
                                                  "\n                  "
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        chatMessage.messageDirection ===
                                        "OUTGOING"
                                          ? _c("span", [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    chatMessage.fromOrganizationMemberInitials
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "right-col" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "message-text",
                                    class: {
                                      "message-failed":
                                        chatMessage.state === "FAILED",
                                      "message-private":
                                        chatMessage.visibility === "PRIVATE",
                                    },
                                  },
                                  [
                                    chatMessage.type !==
                                    _vm.CUSTOMER_CHAT_MESSAGE_TYPES.EVENT
                                      ? _c("div", [
                                          _c("div", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                chatMessage.text
                                              ),
                                            },
                                          }),
                                        ])
                                      : _vm._e(),
                                  ]
                                ),
                                _vm._v(" "),
                                chatMessage.imageUrl
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "message-text message-text-img",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "chat-image" },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: chatMessage.imageUrl,
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                            ]),
                          ]
                        )
                      })
                    ),
                  ])
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c("footer", { staticClass: "chat-footer" }, [
              _c(
                "div",
                { staticClass: "chat-form" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.addChatMessageForm.text,
                        expression: "addChatMessageForm.text",
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: { required: true },
                        expression: "{ required: true }",
                      },
                    ],
                    ref: "chatInputEl",
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      autocomplete: "off",
                      name: "text",
                      placeholder: "Write a message",
                    },
                    domProps: { value: _vm.addChatMessageForm.text },
                    on: {
                      keydown: function ($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k($event.keyCode, "enter", 13, $event.key)
                        ) {
                          return null
                        }
                        _vm.createChatMessage()
                      },
                      keyup: _vm.onChatKeyup,
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.addChatMessageForm,
                          "text",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "btn-spinner",
                    {
                      attrs: {
                        type: "submit",
                        loading: _vm.saving,
                        "icon-right": true,
                        "class-name": "btn btn-send",
                        disabled: _vm.errors.has("text"),
                      },
                      on: {
                        btnClick: function ($event) {
                          _vm.createChatMessage()
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.saving,
                              expression: "!saving",
                            },
                          ],
                        },
                        [
                          _c("i", {
                            staticClass: "icon-send ion-paper-airplane",
                          }),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/loaders/templateLoader.js?{"loaders":{"css":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"postcss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"less":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"less-loader","options":{"sourceMap":true}}],"sass":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"indentedSyntax":true,"sourceMap":true}}],"scss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"sourceMap":true}}],"stylus":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}],"styl":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}]}}!./src/components/CustomerChat/template.html?vue&type=template&id=1736a8ee&
// module id = 1041
// module chunks = 0